import { createFileRoute } from '@tanstack/react-router'
import PlusIcon from '~/components/icons/PlusIcon'
import { CategoriesPageLayout } from '~/components/routes/categories/categories-page-layout'
import { CategoriesPanel } from '~/components/routes/categories/CategoriesPanel'
import { useRights } from '~/utils/hooks'
import { AuthorizedButtonLink, withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/categories/categories')({
  staticData: {
    permission: ['read', 'categories'],
  },
  component: CategoriesTabPage,
})
withRoutePermissions(Route)

function CategoriesTabPage() {
  const isAdmin = useRights(['ADMIN'])

  return (
    <CategoriesPageLayout
      activeTab="categories"
      actions={
        <AuthorizedButtonLink variant="contained" to="/categories/new" disabled={!isAdmin}>
          <PlusIcon />
          Ajouter une catégorie
        </AuthorizedButtonLink>
      }
    >
      <CategoriesPanel />
    </CategoriesPageLayout>
  )
}
